module.exports = __webpack_public_path__ + "img/logo-EUR-tmp.6da6e343.svg";